module.exports = __webpack_public_path__ + "static/photo-president-2e526007f2dea8486452b3b6b9e16cee.jpg";